import type { Store } from './types';

import { Helmet } from '@dr.pogodin/react-helmet';
import * as React from 'react';
import { Provider } from 'react-redux';

import { HubApiReadConfig } from './api';
import App from './App';
import { PageTitleTemplate, Text } from './components';
import { DropdownMutexContextProvider } from './contexts';
import { configureStoreAsync } from './store';

export default function AppLoader() {
  const [isAppReady, setIsAppReady] = React.useState(false);
  const store = React.useRef<Store | null>(null);

  async function preload() {
    store.current = await configureStoreAsync();
    setIsAppReady(true);
  }

  React.useEffect(() => {
    preload();
  });

  return isAppReady ? (
    <Provider store={store.current!}>
      <HubApiReadConfig>
        <DropdownMutexContextProvider>
          <>
            <PageTitleTemplate />
            <Helmet>
              <link
                href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
                rel="stylesheet"
              />
              <link
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css"
                rel="stylesheet"
              />
              <meta
                content="width=device-width, initial-scale=1, maximum-scale=1"
                name="viewport"
              />
            </Helmet>
            <App />
          </>
        </DropdownMutexContextProvider>
      </HubApiReadConfig>
    </Provider>
  ) : (
    <Text as="div">Initialising app</Text>
  );
}
